import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { BotsCreators } from '../../../store/actions/bots';

import './AvailableChannels.scss';

import ChannelCard from './ChannelCard';

import iconServiceWhats from '../../../assets/images/icon_channels_whatsapp.svg';
import iconServiceFacebookMessenger from '../../../assets/images/facebook-messenger-logo.svg';
import iconServiceWebchat from '../../../assets/images/icon_service_webchat.svg';
import iconChannelsBar from '../../../assets/images/icon_channels_bar.svg';
import iconChannelsConfig from '../../../assets/images/icon_channel_settings.svg';
import { ChannelId } from '../../../util/channels';
import Footer from '../../Footer2/index';

import { setAuthState } from '../../../store/actions/facebook-messenger';
import {
  userLogout,
  FACEBOOK_AUTH_RESET,
} from './Components/FacebookMessenger/facebook-api';

class AvailableChannels extends Component {
  componentDidMount() {
    const { retrieveBotRequest, setAuthState, facebookAuth } = this.props;
    const { botid } = this.props.match.params;
    retrieveBotRequest(botid);

    if (facebookAuth.accessToken !== '') {
      const callback = () => {
        setAuthState(FACEBOOK_AUTH_RESET);
      };
      userLogout(callback);
    }
  }

  // publishWidgetHtml = () => {
  //   const {publishBotWidgetHtmlRequest} = this.props
  //   const {botid} = this.props.match.params
  //   const result = publishBotWidgetHtmlRequest(botid)
  // }

  render() {
    // const {i18n, botid} = this.props.match.params
    const {
      i18n,
      bot,
      match: {
        params: { botid },
      },
    } = this.props;

    if (!bot || !bot._id) {
      return null;
    }

    const channelWhatsApp = bot.channels.find(
      (i) => i.channelId === ChannelId.WhatsApp
    );
    const channelFacebookMessenger = bot.channels.find(
      (i) => i.channelId === ChannelId.FacebookMessenger
    );
    const channelWebchat = bot.channels.find(
      (i) => i.channelId === ChannelId.WebChat
    );
    const channelBar = bot.channels.find(
      (i) => i.channelId === ChannelId.ChannelsBar
    );

    return (
      <div className="linha-conteudo">
        <div className="col-md-12 conteudo-iniciar">
          <ChannelCard
            icon={iconChannelsConfig}
            label={i18n.t('Privacidade')}
            showActiveIcon={false}
            href={`/bots/${botid}/canais/configuracao-lgpd`}
            type="config"
          />
          <ChannelCard
            icon={iconServiceWhats}
            label={i18n.t('WhatsApp')}
            showActiveIcon
            active={channelWhatsApp && channelWhatsApp.isActive}
            href={`/bots/${botid}/canais/whatsapp`}
            type="channel"
          />
          <ChannelCard
            icon={iconServiceFacebookMessenger}
            label={i18n.t('Facebook Messenger')}
            showActiveIcon
            active={
              channelFacebookMessenger && channelFacebookMessenger.isActive
            }
            href={`/bots/${botid}/canais/facebook-messenger`}
            type="channel"
          />
          <ChannelCard
            icon={iconServiceWebchat}
            label={i18n.t('Webchat')}
            showActiveIcon
            active={channelWebchat && channelWebchat.isActive}
            href={`/bots/${botid}/canais/widget-html`}
            type="channel"
          />
          <ChannelCard
            icon={iconChannelsBar}
            label={i18n.t('Barra de Canais')}
            showActiveIcon
            active={channelBar && channelBar.isActive}
            href={`/bots/${botid}/canais/barra-de-canais`}
            type="channel"
          />
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  facebookAuth: state.facebookMessenger.facebookAuth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, setAuthState }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(AvailableChannels))
);
